export { default } from './JoinAccountForm.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/JoinAccountForm/index.js